// OIDC config for the celeriant-auth IdP this admin/account console points at. Override per-environment with
// VITE_OIDC_*. `metadataUrl` is explicit because the IdP serves discovery at the host root, not under the
// issuer path.
export interface AuthConfig {
  authority: string;
  metadataUrl?: string;
  clientId: string;
  scope: string;
}

export const authConfig: AuthConfig = {
  authority: import.meta.env.VITE_OIDC_AUTHORITY ?? 'https://192.168.88.214:8443/auth/v1/',
  metadataUrl:
    import.meta.env.VITE_OIDC_METADATA_URL ?? 'https://192.168.88.214:8443/.well-known/openid-configuration',
  clientId: import.meta.env.VITE_OIDC_CLIENT_ID ?? 'celeriant-auth-ui',
  scope: import.meta.env.VITE_OIDC_SCOPE ?? 'openid profile email',
};
